import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { stringify } from 'query-string';
import { useMemo } from 'react';
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { REGISTRATION_TYPE_NORMAL, REGISTRATION_TYPE_COLUMN, REGISTRATION_TYPE_DOCUMENT, REGISTRATION_TYPE_CONSULTANT_SEARCH, REGISTRATION_TYPE_PROFESSIONAL_ONE, REGISTRATION_TYPE_PROFESSIONAL_UNIT, } from '@/define/consts/registration';
import { propBool, propChildren, propFunc, propStr, propOneOfType, } from '@/helpers/custom-prop-types';
/**
 * 会員登録ページへのリンクを制御するコンポーネント
 * @deprecated 関数化+TS化済 src/utils/resources/registration/registrationLink.ts (getRegistrationLink)
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const RegistrationLink = (props) => {
    const { className, isNoLinkComponent, onClick, text } = props;
    const registrationLink = useMemo(() => {
        const { href: ref, pathname } = window.location;
        const path = pathname.replace(/\/$/, '');
        // 登録経路の種別を判定
        let { type } = [
            { route: '/column/', type: REGISTRATION_TYPE_COLUMN },
            { route: '/document', type: REGISTRATION_TYPE_DOCUMENT },
            {
                route: '/consultant_unit/',
                type: REGISTRATION_TYPE_PROFESSIONAL_UNIT,
            },
            {
                route: '/consultant/search',
                type: REGISTRATION_TYPE_CONSULTANT_SEARCH,
            },
            { route: '/consultant/', type: REGISTRATION_TYPE_PROFESSIONAL_ONE },
        ].find((v) => path.indexOf(v.route) === 0) || {};
        if (!type) {
            type = REGISTRATION_TYPE_NORMAL;
        }
        return `/registration?${stringify({ ref, type })}`;
    }, []);
    return (_jsx(DynamicLink, Object.assign({ className: className, noLinkElement: isNoLinkComponent, onClick: onClick, onClickNoLink: onClick, to: registrationLink }, { children: text })));
};
RegistrationLink.propTypes = {
    className: propStr(),
    isNoLinkComponent: propOneOfType([propBool(), propStr()]),
    onClick: propFunc(),
    text: propChildren(),
};
RegistrationLink.defaultProps = {
    className: '',
    isNoLinkComponent: undefined,
    onClick: undefined,
    text: '会員登録（無料）',
};
export default RegistrationLink;
